<section class="about-section-three section-gap">
  <div class="container">
    <div class="row justify-content-center">
      <div
        class="col-lg-6 col-md-10 order-2 order-lg-1"
        *transloco="let t; read: 'home'"
      >
        <div class="about-text-three">
          <div class="section-title left-border mb-40">
            <span class="title-tag">{{ t("about") }}</span>
            <h2 class="title">
              {{ t("title_about") }}
            </h2>
          </div>
          <p class="mb-25">{{ t("text_about") }}</p>
          <a
            class="main-btn main-btn-4"
            [routerLink]="['', 'services']"
            data-aos="fade-left"
            >{{ t("button1") }}</a
          >
        </div>
      </div>
      <div class="col-lg-6 col-md-10 order-1 order-lg-2">
        <div class="about-tile-gallery">
          <img
            data-aos="fade-left"
            src="assets/img/video-bg/01.png"
            alt="Image"
            class="image-one wow"
          />
          <!-- data-wow-duration="1500ms"
            data-wow-delay="400ms" -->
          <img
            data-aos="fade-right"
            src="assets/img/video-bg/02.png"
            alt="Image"
            class="image-two wow"
          />

          <!-- data-wow-duration="1500ms"
            data-wow-delay="600ms" -->
        </div>
      </div>
    </div>
  </div>
</section>
